module.exports = __webpack_public_path__ + "img/39ne.04791cfd.svg";